
import { requester } from "App";
import { textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";

import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { validateInputs } from "shared/utils/Utils";

function VendingRegister() {
    const inputs = useRef([]);
    const searchRef = useRef();
    const selectRef = useRef();
    const { t } = useTranslation();
    const [duplicateCheck, setDuplicateCheck] = useState(true);
    const id = 'root';
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);
    const { userId, userName } = useContext(AuthContext);
    const [searchResults, setSearchResults] = useState();
    const [selectedVendorId, setSelectedVendorId] = useState();

    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        let data = { storeId: 'root' }
        requester.findAllVendor(data, (result) => {
            
        })
        
    }, [isMounted])


    const onClick = () => {

        let data = { vendorId: selectedVendorId, vendingName: '' }

        if (selectedVendorId) {
            validateInputs(inputs.current).then((result) => {
                if (result.isValid) {
                    data.vendingName = inputs.current[0].getValue();
                    requester.createVending(data, (result) => {
                        
                    })
                } else {
                    toast.error(t("pleaseCheck"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            });

        }
        else {
            toast.error(t("pleaseCheck"), {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }
    }
    const search = () => {
        
        let data = { userName: searchRef.current.getValue() }
        requester.searchVendor(data, (result) => {
            setSearchResults(result.data);
        })

    }

    const handleSelectChange = (e) => {
        
        setSelectedVendorId(e.target.value); // 선택된 값으로 상태 업데이트
    };

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <Center width={"100%"} textAlign={"left"}>
                            <P size={40} font={"gmarketSansBold"} color={"black"}>자판기 등록</P>
                        </Center>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"}>
                                <P>자판기 이름</P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[0] = el)} regExp={[textFormat]} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>점주찾기 : </P>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <InputText ref={searchRef} placeHolder={"점주 ID 검색"} />
                                    </FlexChild>
                                    <FlexChild>
                                        <CustomButton text={"검색"} style={btnStyle} onClick={search} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {
                        searchResults &&
                        searchResults.length > 0 && (
                            <FlexChild>
                                <select onChange={handleSelectChange} ref={selectRef} value={selectedVendorId}>
                                    <option value={""}>선택하세요</option>
                                    {searchResults.map((vendor, index) => (
                                        <option key={index} value={vendor.id}>
                                            {vendor.userName}
                                        </option>
                                    ))}
                                </select>
                            </FlexChild>
                        )
                    }

                    <FlexChild>
                        <CustomButton text={"기기등록"} style={btnStyle} onClick={onClick} />
                    </FlexChild>
                </VerticalFlex>


            </Container>
        </Container >
    );
}

export default VendingRegister;